/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';

import {
  Grid,
  InputLabel,
  Link,
  TextField,
  Box,
  Chip,
  Typography,
} from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';

import clsx from 'clsx';
import { EQueryStringKey } from 'services/QueryString/QueryStringService';
import { setLanguageLabel } from 'pages/labels/languageLabels';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatusType } from '../../enums/status-type.enum';
import { useStateCollection } from '../../hooks/useStateCollection/useStateCollection.hook';
import {
  createValidatorContext,
  useContentValidator,
} from '../../services/ContentValidator/ContentValidator';
import { IValidationResult } from '../../services/ContentValidator/interfaces/validation.interface';
import { countries as countriesList } from '../../utils/countries';
import { getFriendlyErrorMessage } from '../../utils/errorHelper';
import slugify from '../../utils/slugify';
import { BlocksContents } from '../BlocksContents';
import Brand from '../Brand';
import Tag from '../DisplayTag';
import ImageUploadPreviewer from '../ImageUploadPreviewer/ImageUploadPreviewer';
import Loading from '../Loading';
import Product from '../Product';
import TextEditor from '../TextEditor';
import { Toast } from '../Toast';
import ContentAnalysisModal from './components/ContentAnalysisModal/ContentAnalysisModal';
import useStyles from './styles';
import { useUserData } from '../../hooks/context/userUserData.hook';
import { getNameFromArticleType } from '../../utils/getNameFromArticleType';
import { ArticleType } from '../../enums/articleType.enum';
import ActionButtons from './components/ActionButtons/ActionButtons';
import { PublishContentButton } from './components/ActionButtons/PublishContentButton';

interface IFormContentsProps {
  data: ITitle & { [key: string]: any };
  updateContentMutation: any;
  setShowDrawer: any;
  refetchContent: any;
  permissions: any;
  dynamicFields: any;
  isStartRevision?: boolean;
  TimerToReview?: JSX.Element;
}

const FormContents: React.FC<IFormContentsProps> = ({
  data,
  updateContentMutation,
  setShowDrawer,
  refetchContent,
  permissions,
  dynamicFields,
  isStartRevision,
  TimerToReview,
}) => {
  const location = useLocation();
  const history = useHistory();

  const useStateInCollection = useStateCollection();
  const [user] = useUserData();
  const classes = useStyles();

  const [titleId] = useState(data ? data.id : '');
  const [title] = useState(data ? data.title : '');
  const [titleContent, setTitleContent] = useState(
    data ? data.titleContent : '',
  );
  const [content, setContent] = useStateInCollection(
    'content',
    data ? data.content : '',
  );
  const [featuredImage, setFeaturedImage] = useState(
    data ? data.featuredImage : '',
  );
  const [focusKeyword] = useState(data ? data.focusKeyword : '');
  const [suggestedKeywords] = useState(data ? data.suggestedKeywords : '');
  const [usedKeywords, setUsedKeywords] = useState(
    data ? data.usedKeywords : '',
  );
  const [researchLinks] = useState(data ? data.researchLinks : '');
  const [status, setStatus] = useState(data.status);
  const [comments] = useState(data.comments);
  const [countries] = useStateInCollection('countries', data.countries);
  const [permalink, setPermalink] = useState(
    data.permalink ? data.permalink : slugify(title),
  );
  const [smallSeoToolsReport, setSmallSeoToolsReport] = useState(
    data.smallSeoToolsReport,
  );
  const [postUrl] = useState(data.postUrl);
  const [siteDomain] = useState(data.siteDomain);
  const [writerId] = useState(data.writerId);
  const [editorId] = useState(data.editorId);
  const [statusAtWP] = useState(data ? parseInt(data.statusAtWP, 10) : null);
  const [contentId, setContentId] = useState(data.contentId);
  const [tag] = useStateInCollection('tag', data.tag);
  const [slug] = useState(data.slug);
  const [errorTitleContent, setErrorTitleContent] = useState(false);
  const [errorContent, setErrorContent] = useState(false);
  const [errorPermalink, setErrorPermalink] = useState(false);
  const [errorFeaturedImage, setErrorFeaturedImage] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [buttonsPublishDisabled, setButtonsPublishDisabled] = useState(false);
  const [fileToUpload, setFileToUpload] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [pagination] = useState(data ? data.pagination : false);
  const [isSavingContent, setIsSavingContent] = useState(false);
  const [dynamicFieldsList] = useState(dynamicFields || '');
  const [brandId] = useState(data.brandId);
  const [productId] = useState(data.productId);
  const [articleType] = useStateInCollection('articleType', data.articleType);
  const canEdit = useState(
    permissions.canEdit == null ? true : permissions.canEdit,
  );
  const [lastContent, setLastContent] = useState(content);
  const [autosaveLoading, setAutosaveLoading] = useState(false);
  const [autosaveLoadingText, setAutosaveLoadingText] = useState('');
  const [isToVerifyBase64, setIsToVerifyBase64] = useState(
    !!data.featuredImage,
  );

  const [validationModalOpen, setValidationModalOpen] = useState(false);
  const [validationResult, setValidationResult] = useState<IValidationResult>({
    errors: [],
    warnings: [],
  });

  const [, setEditorWordCount] = useStateInCollection('wordCount', 0);

  const AUTOSAVE_INTERVAL = 2000;

  useEffect(() => {
    if (data) {
      setContentId(data.contentId);
      setStatus(data.status);
    }
  }, [data]);

  useEffect(() => {
    if (contentId && buttonsDisabled) {
      // setButtonsDisabled(false);
      setTimeout(() => {
        if (openBackdrop) {
          setOpenBackdrop(false);
        }
      }, 1000);
    }
  }, [contentId, buttonsDisabled]);

  useEffect(() => {
    const timer = setTimeout(async () => {
      if (content !== '' && lastContent !== content) {
        setAutosaveLoading(true);
        setAutosaveLoadingText('⏳ saving...');
        await updateContent(status, false, false, true);

        setLastContent(content);
      }
    }, AUTOSAVE_INTERVAL);
    return () => clearTimeout(timer);
  }, [content]);

  useEffect(() => {
    if (validationModalOpen) {
      const newValidationResult = validate();
      setValidationResult(newValidationResult);
    }
  }, [validationModalOpen]);

  useEffect(() => {
    const patternsErrors = validationResult.errors.find((error) => {
      return error.meta?.validator === 'patterns';
    })?.details;

    const stylesheet = document.getElementById('editor-errors-style');
    if (stylesheet) {
      stylesheet.remove();
    }

    let resultStylesheetHtml = '';
    if (patternsErrors) {
      const filteredErrors = patternsErrors.filter((error) => {
        return (
          error.category === getNameFromArticleType(articleType as ArticleType)
        );
      });

      filteredErrors.forEach((error) => {
        resultStylesheetHtml += `
          #ckeditor > div > *:nth-child(${error.meta?.line})::${
          error.meta?.showWhere
            ? error.meta?.showWhere
            : error.meta?.type === 'incorrect-amount'
            ? 'before'
            : 'after'
        } {
            content: "${error.meta?.resumed}";
            display: flex;
            border: 1px solid red;
            background-color: rgba(247, 77, 102, 0.15);
            margin: 4px 0;
            border-radius: 3px;
            padding: 5px;
            font-weight: 400;
            font-size: 14px;
          }
        `;
      });
    }

    validationResult.warnings.forEach((warning) => {
      if (warning.meta?.validator === 'image') {
        resultStylesheetHtml += `
          #ckeditor > div > *:nth-child(${warning.meta?.line}) > img {
            border: 2.5px dashed #e38264;
          }
        `;
      }
    });

    const styleEl = document.createElement('style');
    styleEl.innerHTML = resultStylesheetHtml;
    styleEl.id = 'editor-errors-style';
    document.head.appendChild(styleEl);
  }, [articleType, validationResult]);

  useStateInCollection.addNonState(
    'onAnalysisChange',
    (analysisResult: IValidationResult) => {
      setValidationResult(analysisResult);
    },
  );

  useStateInCollection.addNonState(
    'htmlNodes',
    document.getElementsByClassName('ck-content')[0]?.childNodes,
  );

  useStateInCollection.addNonState('siteDomain', siteDomain);

  const context = createValidatorContext(useStateInCollection.getStates());
  const validate = useContentValidator(context);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setErrorTitleContent(false);
    setButtonsDisabled(false);
    setTitleContent(event.target.value);
  };

  const handleChangePermalink = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    const generatedPermalink = slugify(event.target.value);
    setErrorPermalink(false);
    setPermalink(generatedPermalink);
  };

  const renderFocusKeyword = (focusKeywordToRender: string) => {
    return focusKeywordToRender
      .split(',')
      .filter((keyword) => {
        return keyword.length > 0;
      })
      .map((keyword, index) => (
        <Chip label={keyword} key={index} color="primary" size="small" />
      ));
  };

  const renderSuggestedWordsAsLinkOrLabels = (
    suggestedKeywordsToRender: string,
  ) => {
    const urlRegex = /((http|https):\/\/)?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;
    const urlMatch = suggestedKeywordsToRender.match(urlRegex);

    if (urlMatch) {
      return (
        <a
          href={suggestedKeywordsToRender}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.linkToSheets}
        >
          <FontAwesomeIcon
            color="grey"
            icon={['far', 'file-alt']}
            style={{ marginRight: 8, fontSize: 20 }}
          />

          <span>Link to sheets</span>
        </a>
      );
    }

    return suggestedKeywordsToRender
      .split(',')
      .filter((keyword) => {
        return keyword.length > 0;
      })
      .map((keyword, index) => (
        <Chip label={keyword} key={index} color="primary" size="small" />
      ));
  };

  const setStatusWP = (status: number) => {
    if (status === StatusType.WaitPublish) {
      return 3;
    }
    return 2;
  };

  const checkEmptyFields = (saveCheck: boolean) => {
    let error = false;
    if (!titleContent || titleContent.length === 0) {
      setErrorTitleContent(true);
      error = true;
    }
    if (!content || content.length === 0) {
      setErrorContent(true);
      Toast('Content must be added!', 'error');
      error = true;
    }
    if (!saveCheck) {
      if (!permalink || permalink.length === 0) {
        setErrorPermalink(true);
        error = true;
      }

      if (
        !featuredImage &&
        !slug &&
        !fileToUpload &&
        articleType !== ArticleType.Presell
      ) {
        setErrorFeaturedImage(true);
        Toast('A Featured Image must be added!', 'warning');
        error = true;
      }
    }
    return error;
  };

  const handlePermalinkError = (message: string) => {
    if (
      message.toLowerCase().includes('permalink') ||
      message.toLowerCase().includes('title generates a permalink')
    ) {
      setErrorPermalink(true);
    }
  };

  const onCompleted = (
    closeDrawer: boolean,
    autosave: boolean,
    sendWp: boolean,
    dataUpdateContent?: any,
  ) => {
    if (closeDrawer) {
      setShowDrawer(false);
      const params = new URLSearchParams(location.search);
      params.delete(EQueryStringKey.TitleId);
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    }

    !autosave && Toast('Action executed with success!');
    setAutosaveLoadingText('💾 saved ✔');
    setIsSavingContent(false);

    if (refetchContent) {
      refetchContent();
    }

    if (contentId || sendWp) {
      setOpenBackdrop(false);
      setButtonsDisabled(false);
    }

    setIsToVerifyBase64(true);

    if (dataUpdateContent) {
      if (
        !dataUpdateContent.featuredImage.startsWith('http') ||
        dataUpdateContent.content.match(/src="(data:image\/[^;]+;base64[^"]+)"/)
      ) {
        setButtonsPublishDisabled(true);
      } else {
        setButtonsPublishDisabled(false);
      }
    }
  };

  const onError = (message: string) => {
    handlePermalinkError(message);
    Toast(message, 'error');
    checkEmptyFields(false);
    setButtonsDisabled(false);
    setOpenBackdrop(false);
    setIsSavingContent(false);
  };

  const updateContent = async (
    status: number,
    sendWp = true,
    closeDrawer = true,
    autosave = false,
    publishContent?: () => void,
  ) => {
    if (checkEmptyFields(autosave)) return;

    setButtonsDisabled(true);
    setOpenBackdrop(!autosave);
    setIsSavingContent(true);
    const values = {
      id: contentId,
      titleId,
      titleContent,
      title,
      content,
      writerId: !writerId
        ? user.id
        : user.role === 'WRITER'
        ? user.id
        : writerId,
      photos: [''],
      featuredImage: fileToUpload.length > 0 ? fileToUpload : featuredImage,
      statusAtWP: sendWp ? setStatusWP(status) : statusAtWP,
      sendWp: false,
      theContentWasReproved: sendWp ? false : null,
      permalink: permalink || '',
      smallSeoToolsReport: smallSeoToolsReport || '',
      editorId: !editorId ? (user.role === 'EDITOR' ? user.id : '') : editorId,
      slug,
      usedKeywords,
    };

    updateContentMutation({
      variables: values,
    }).then(
      (data: any) => {
        if (!publishContent) {
          const dataContent =
            data.data.updateContent || data.data.createContent;

          onCompleted(closeDrawer, autosave, sendWp, dataContent);
        } else if (publishContent && sendWp) {
          publishContent();
        }
      },
      (error: any) => {
        onError(getFriendlyErrorMessage(error));
      },
    );
  };

  const rejectContent = () => {
    const values = {
      id: contentId,
      titleId,
      titleContent,
      content,
      theContentWasReproved: true,
      featuredImage: fileToUpload.length > 0 ? fileToUpload : featuredImage,
      smallSeoToolsReport: smallSeoToolsReport || '',
    };

    updateContentMutation({
      variables: values,
    }).then(
      () => {
        Toast('Title rejected!');
        if (refetchContent) {
          refetchContent();
        }

        setShowDrawer(false);
        const params = new URLSearchParams(location.search);
        params.delete(EQueryStringKey.TitleId);
        history.replace({
          pathname: location.pathname,
          search: params.toString(),
        });
      },
      (error: any) => {
        Toast(getFriendlyErrorMessage(error), 'error');
      },
    );
  };

  const changeWordCount = (wordCount: number) => {
    setEditorWordCount(wordCount);
  };

  const handleContentAnalysisModalClose = () => {
    setValidationModalOpen(false);
  };

  const onSelectFeaturedImage = (image: string) => {
    setIsToVerifyBase64(false);
    setFileToUpload(image);
    setFeaturedImage(image);
  };

  // useEffect(() => {
  //   console.log('featuredImage changed ->', data.featuredImage);
  // }, [data.featuredImage]);

  const imageIsBase64 = () => {
    return !!data?.featuredImage?.match(/^data:image\/(png|jpg|jpeg);base64,/g);
  };

  return (
    <form id="myForm" className={classes.container}>
      <Loading openLoading={openBackdrop} />
      <div className={classes.mainContent}>
        <div>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <InputLabel className={classes.inputLabel}>Title</InputLabel>
              {title}
            </Grid>

            {data?.language && (
              <Grid item xs={12}>
                <InputLabel className={classes.inputLabel}>Language</InputLabel>
                {setLanguageLabel(data?.language)}
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                className={classes.inputLabel}
                error={errorTitleContent}
                autoFocus
                id="title"
                label="Title content"
                onChange={handleChange}
                value={titleContent || ''}
                color="primary"
                fullWidth
                disabled={!canEdit}
              />
            </Grid>

            {permissions.showSiteDomain && (
              <Grid item xs={12}>
                <InputLabel className={classes.inputLabel}>
                  Site Domain
                </InputLabel>
                {siteDomain}
              </Grid>
            )}

            {permissions.showPermalink && !slug && (
              <Grid item xs={12}>
                <TextField
                  className={classes.inputLabel}
                  error={errorPermalink}
                  disabled={status === 7 || !canEdit}
                  id="permalink"
                  label="Permalink"
                  onChange={handleChangePermalink}
                  value={permalink}
                  color="primary"
                  fullWidth
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <Typography
                variant="h2"
                component="h2"
                className={classes.textTitleContent}
              >
                {titleContent}
              </Typography>
            </Grid>

            {focusKeyword && (
              <Grid item xs={12}>
                <InputLabel className={classes.textInput}>
                  Focus Keyword
                </InputLabel>

                {renderFocusKeyword(focusKeyword)}
              </Grid>
            )}

            {suggestedKeywords && (
              <Grid item xs={12}>
                <InputLabel className={classes.textInput}>
                  Related Keywords
                </InputLabel>

                {renderSuggestedWordsAsLinkOrLabels(suggestedKeywords)}
              </Grid>
            )}

            <Grid item xs={12}>
              {pagination ? (
                <BlocksContents
                  content={content}
                  setContent={setContent}
                  titleId={titleId}
                  siteDomain={siteDomain}
                  isSavingContent={isSavingContent}
                  dynamicFieldsStringified={dynamicFieldsList}
                  showDynamicFields={permissions.showDynamicFields}
                  isAutoSaving={autosaveLoading}
                  autoSavingText={autosaveLoadingText}
                />
              ) : (
                <>
                  {autosaveLoading && (
                    <Box p={1} className={classes.autoSaveLoadingContainer}>
                      <Typography
                        component="p"
                        className={classes.autosaveLoading}
                      >
                        {autosaveLoadingText}
                      </Typography>
                    </Box>
                  )}
                  <TextEditor
                    content={content}
                    setContent={setContent}
                    errorContent={errorContent}
                    siteDomain={siteDomain}
                    dynamicFieldsList={dynamicFieldsList}
                    dynamicFieldsConfig={{
                      showDynamicFields: permissions.showDynamicFields,
                      showProductDynamicFields: !!productId,
                      showBrandDynamicFields: !!brandId,
                      showPresellDynamicFields:
                        articleType === ArticleType.Presell,
                    }}
                    onWordCountChanged={changeWordCount}
                  />
                </>
              )}
            </Grid>
          </Grid>
        </div>

        <div>
          <Grid container spacing={1}>
            <ActionButtons
              buttonsDisabled={buttonsDisabled}
              checkEmptyFields={checkEmptyFields}
              validate={validate}
              onSaveContent={updateContent}
              onUpdateContent={updateContent}
              permissions={permissions}
              setValidationModalOpen={setValidationModalOpen}
              validationResult={validationResult}
              setValidationResult={setValidationResult}
              status={status}
              titleId={titleId}
              user={user}
              inReview={data.inReview}
              onRejectContent={rejectContent}
              isStartRevision={isStartRevision}
              TimerToReview={TimerToReview}
              siteDomain={siteDomain}
            />

            <PublishContentButton
              setValidationModalOpen={setValidationModalOpen}
              setValidationResult={setValidationResult}
              validationResult={validationResult}
              validate={validate}
              setButtonsDisabled={setButtonsDisabled}
              buttonsDisabled={buttonsDisabled || buttonsPublishDisabled}
              permissions={permissions}
              user={user}
              contentId={data.contentId}
              onCompleted={onCompleted}
              onError={onError}
              onUpdateContent={updateContent}
            />

            <ImageUploadPreviewer
              name="Featured Image"
              externalErrorControl={{
                error: errorFeaturedImage,
                setError: setErrorFeaturedImage,
              }}
              permissions={{
                canEdit: canEdit[0],
                canViewImageLink: permissions.showFeaturedImageLink,
              }}
              onSelect={onSelectFeaturedImage}
              initialValue={data.featuredImage}
              isToShowBase64Error={isToVerifyBase64 && imageIsBase64()}
              siteDomain={siteDomain}
            />

            <Grid item xs={12}>
              <TextField
                id="keywords"
                label="Keywords (One per line)"
                multiline
                rows={5}
                onChange={({ target }) => setUsedKeywords(target.value)}
                value={usedKeywords}
                color="primary"
                fullWidth
              />
            </Grid>

            {researchLinks && (
              <Grid item xs={12}>
                <InputLabel className={classes.textInput}>
                  Research Links
                </InputLabel>
                {researchLinks
                  ? researchLinks
                      .split(',')
                      .filter((link) => {
                        return link.length > 0;
                      })
                      .map((link, index) => (
                        <Link
                          href={link}
                          key={index}
                          target="_blank"
                          rel="noopener"
                          color="inherit"
                        >
                          <Box>{link}</Box>
                        </Link>
                      ))
                  : null}
              </Grid>
            )}
            {comments && (
              <Grid item xs={12}>
                <InputLabel className={classes.textInput}> Comments</InputLabel>
                <Box>{comments}</Box>
              </Grid>
            )}
            {countries.length > 0 && (
              <Grid item xs={12}>
                <InputLabel className={classes.textInput}>
                  {' '}
                  Countries
                </InputLabel>
                <Box>
                  {countries.map((country) => {
                    return (
                      <Chip
                        label={
                          countriesList.find(
                            (_country) => _country.code === country,
                          )
                            ? countriesList.find(
                                (_country) => _country.code === country,
                              )?.name
                            : ''
                        }
                        key={country}
                        color="primary"
                        size="small"
                      />
                    );
                  })}
                </Box>
              </Grid>
            )}
            {permissions.showTag && <Tag tag={tag} />}

            {permissions.showSmallSeoToolsReport && (
              <Grid item xs={12}>
                <TextField
                  className={classes.inputLabel}
                  id="smallSeoToolsReport"
                  label="Plagiarism Report URL"
                  onChange={({ target }) => {
                    return setSmallSeoToolsReport(target.value);
                  }}
                  value={smallSeoToolsReport}
                  color="primary"
                  fullWidth
                />
              </Grid>
            )}
            {permissions.showPostUrl && postUrl && (
              <Grid item xs={12}>
                <InputLabel className={classes.inputLabel}>
                  {' '}
                  Post Url
                </InputLabel>
                <Link
                  href={postUrl}
                  target="_blank"
                  rel="noopener"
                  color="inherit"
                >
                  {postUrl}
                </Link>
              </Grid>
            )}
            {slug && (
              <Grid item xs={12}>
                <InputLabel className={classes.inputLabel}>Slug</InputLabel>
                <Chip
                  label={slug}
                  key="slug"
                  color="secondary"
                  size="medium"
                  className={classes.chip}
                />
              </Grid>
            )}

            {tag === 'ar' && (
              <Grid
                item
                xs={12}
                className={clsx(classes.flatPaper, classes.row)}
              >
                <Typography className={classes.flatPaperText}>
                  Article Type (Validator):
                </Typography>
                <Typography className={classes.articleTypeText}>
                  {getNameFromArticleType(articleType as ArticleType)}
                </Typography>
              </Grid>
            )}

            {permissions.showBrandsContents && brandId && (
              <Brand brandId={brandId} save={isSavingContent} />
            )}
            {permissions.showProductsContents && productId && (
              <Product
                productId={productId}
                brandId={brandId}
                save={isSavingContent}
              />
            )}
          </Grid>
        </div>
      </div>

      <ContentAnalysisModal
        open={validationModalOpen}
        handleClose={handleContentAnalysisModalClose}
        analysis={validationResult}
      />
    </form>
  );
};

export default FormContents;
